angular.module('surfsightApp.controllers').controller('LogoutCtrl', [
  '$scope',
  '$rootScope',
  '$log',
  '$state',
  '$timeout',
  '$location',
  '$http',
  '$filter',
  '$mdDialog',
  '$mdSidenav',
  '$mdToast',
  '$mdColors',
  '$localStorage',
  'edgeFactory',
  'edgeFactoryV2',
  'edgeGroupFactory',
  'edgeGroupFactoryV2',
  'broadcastViewFactory',
  'userFactory',
  function (
    $scope,
    $rootScope,
    $log,
    $state,
    $timeout,
    $location,
    $http,
    $filter,
    $mdDialog,
    $mdSidenav,
    $mdToast,
    $mdColors,
    $localStorage,
    edgeFactory,
    edgeFactoryV2,
    edgeGroupFactory,
    edgeGroupFactoryV2,
    broadcastViewFactory,
    userFactory
  ) {
    if ($localStorage.isResellerSso) {
      delete $localStorage.userToken
      delete $localStorage.userDetails
      if (window.heap) {
        window.heap.resetIdentity()
      }
      setTimeout(function () {
        $state.go('home.login')
      })
      return
    }
    const logout = () => {
      delete $localStorage.userToken
      delete $localStorage.userDetails
      delete $localStorage.userOrganization
      delete $localStorage.selectedOrganization
      delete $localStorage.currentUserOrganization
      delete $localStorage.userMediaAccessToken
      delete $localStorage.isResellerSso
      delete $localStorage.timeFormat
      delete $localStorage.measurementUnits
      delete $localStorage.alarmsCount
      userFactory.clearAuth()

      if (window.heap) {
        window.heap.resetIdentity()
      }
      edgeFactory.list.splice(0, edgeFactory.list.length)
      edgeFactoryV2.clear()
      edgeGroupFactory.list.splice(0, edgeGroupFactory.list.length)
      edgeGroupFactoryV2.clear()
      broadcastViewFactory.list.splice(0, broadcastViewFactory.list.length)
      setTimeout(function () {
        $state.go('home.login')
      })
    }
    $http({
      method: 'POST',
      url: USER_BASEURL + '/logout',
      data: {}
    }).then(logout, logout)
  }
])
